import React from 'react';
import styled from 'packages/theming';
import { useRouteMatch } from 'react-router-dom';
import { Box, Loading, constants } from '@match/react-component-library';
import { MobiHeader, Footer, Greeting, Search } from 'modules/components';
import { useCategories } from 'modules/hooks';

const { SPACE } = constants;

export interface FaqMobiLayoutProps {
  handle?: string;
}

const FaqMobiLayout: React.FunctionComponent<FaqMobiLayoutProps> = ({ children, handle }) => {
  const { areCategoriesLoading } = useCategories();
  const routeMatch = useRouteMatch('/');
  const isLandingPage = routeMatch && routeMatch.isExact;
  const checkLandingForHeight = isLandingPage ? 200 : 100;
  return (
    <Box>
      <MobiHeader />
      <Box width="100%" height="100%" position="absolute">
        <Box width="100%" display="flex" justifyContent="center">
          <StyledBox
            width="375px"
            marginBottom={SPACE.XLARGE}
            position="relative"
            paddingBottom={SPACE.LARGE}
            display="flex"
            flexDirection="column"
            center
          >
            <Box
              alignItems="center"
              display="flex"
              flexDirection="column"
              justifyContent="space-around"
              height={checkLandingForHeight}
              paddingTop={SPACE.XXXLARGE}
              marginTop={SPACE.XXLARGE}
              width="100%"
            >
              {isLandingPage && (
                <Box paddingX={SPACE.MEDIUM}>
                  <Greeting handle={handle} />
                </Box>
              )}
              <Search isMobi />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              marginTop={SPACE.LARGE}
              width="100%"
            >
              {areCategoriesLoading ? (
                <Box center width="100%" height="100%">
                  <Loading />
                </Box>
              ) : (
                <React.Fragment>{children}</React.Fragment>
              )}
            </Box>
            <Footer isMobi />
          </StyledBox>
        </Box>
      </Box>
    </Box>
  );
};

export default FaqMobiLayout;

const StyledBox = styled(Box)(() => {
  return {
    overflow: 'auto',
  };
});
